import { navItems } from "@/mocks/siteContent";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/15 text-background-50">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-lg tracking-wide text-background-50">伦理片在线观看</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/75">
              一个专注伦理片推荐的内容页面：用排行榜、主题合集、编辑手记与观影指南，把选片这件事变得清晰一点。所有条目信息均用于观影选择参考，持续维护与更新。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full border border-background-50/20 px-3 py-1 font-label text-xs text-background-100/80">
                高清中字
              </span>
              <span className="rounded-full border border-background-50/20 px-3 py-1 font-label text-xs text-background-100/80">
                榜单更新
              </span>
              <span className="rounded-full border border-background-50/20 px-3 py-1 font-label text-xs text-background-100/80">
                主题合集
              </span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <h2 className="font-label text-xs uppercase tracking-[0.25em] text-background-100/60">页面导航</h2>
            <ul className="mt-4 grid grid-cols-2 gap-y-2.5 sm:grid-cols-2 lg:grid-cols-1">
              {navItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="text-sm text-background-100/80 transition-colors hover:text-background-50"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h2 className="font-label text-xs uppercase tracking-[0.25em] text-background-100/60">内容说明</h2>
            <p className="mt-4 text-sm leading-relaxed text-background-100/75">
              本页面为内容推荐与信息整理页，不提供影片的在线播放、下载或存储服务，页面内的评分、热度与简介均为便于选择而整理的参考信息。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-background-100/75">
              影片的著作权归各自权利人所有。如页面内容涉及权益问题，我们会根据反馈及时调整或移除相关条目。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-background-50/15 pt-6 text-xs text-background-100/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 伦理片在线观看 · 内容推荐与整理</p>
          <p>请合理安排观影时间，注意用眼健康。</p>
        </div>
      </div>
    </footer>
  );
}